<div class="">
  <div class="mb-4">
    <div class="d-flex justify-content-between">
      <p class="f-16 font-weight-600 mb-1"> Where is the talent distributed?</p>
      <div  class="text-right" style="width: 100px;" *ngIf="personInsightsData?.topLocations?.length">
      <p class="text-webbtree-green f-14 font-weight-500 pointer" (click)="startFreeTrial()">View All</p>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <div style="border:1px solid #d5dee6">
          <div id="workCountryChartDD"
          [hidden]="!(personInsightsData?.dataSourceWorkCountry && personInsightsData?.dataSourceWorkCountry?.length)"
          *ngIf="personInsightsData?.dataSourceWorkCountry?.length" style="width: auto;"></div>
        </div>
        <!-- <div class="loader text-center" >
          <img *ngIf="personInsightsData.dataSourceWorkCountry" style="width: 75px;" src="../../assets/rolling-loader.gif" alt="loader" />
          <span *ngIf="personInsightsData?.dataSourceWorkCountry?.length == 0">No Data Available for map highlights</span>
        </div> -->
      </div>
      <div class="col-md-6">
        <div class="loader text-center d-flex align-items-center justify-content-center" style="height: 100px; border: 1px solid #d5dee6 ;" *ngIf="!personInsightsData?.topLocations?.length">
          <img *ngIf="!personInsightsData.topLocations" style="width: 75px;" src="../../assets/rolling-loader.gif" alt="loader" />
          <span *ngIf="personInsightsData?.topLocations?.length == 0">No data available for top location</span>
        </div>
        <ng-container>
          <div class="table-container" *ngIf="personInsightsData?.topLocations?.length">
          <div class="tableheadertext">
            <span>Top Cities</span>
            <span>Talent Count</span>
          </div>

          <div>
            <div class="table-row mb-4" *ngFor="let location of personInsightsData?.topLocations?.slice(0,5)">
              <div class="d-flex align-items-center justify-content-between mb-4">
                <div class="text-truncate">{{location.key | titlecase}}</div>
                <div class=" font-weight-600">
                  <span>
                    {{location.doc_count | number}}
                  </span>
                </div>
              </div>
              <hr class="HR-seperator-in-card">
            </div>
          </div>

        </div>
        </ng-container>
      </div>
    </div>
  </div>
  <div class="unlimited-acces-box">
    <div class="smtext">
      <p>Access Unlimited Insights</p>
      <p>Upgrade to unlock detailed insights on employee tenure, diversity, seniority, and more. <br>Gain a complete view to make data-driven hiring decisions.</p>
    </div>
    <div>
      <button data-testid="auto-app-webbtree-insights-button-1" class="btn-free-trial-yellow" (click)="startFreeTrial('Get_Unlimited_Access_Insights_Free_Trial')"><i class="fas fa-crown"></i> Start Free Trial</button>
    </div>
  </div>
  <div>
    <div class="d-flex justify-content-between">

    <p class="f-16 font-weight-600 mb-1"> Which companies and industries are employing this talent?</p>
    <div  class="text-right" style="width: 100px;" *ngIf="personInsightsData?.dataSourceCurrentCompany?.data?.length">
      <p class="text-webbtree-green f-14 font-weight-500 pointer" (click)="startFreeTrial('Get_Company_Industry_ViewAll_Free_Trial')">View All</p>
    </div>

    </div>
    <div class="loader text-center d-flex align-items-center justify-content-center mb-3" style="height: 100px; border: 1px solid #d5dee6 " *ngIf="!personInsightsData?.dataSourceCurrentCompany?.data?.length">

      <span *ngIf="personInsightsData?.dataSourceCurrentCompany?.data?.length == 0">No Data Available</span>
    </div>
    <div class="row mb-2" *ngIf="personInsightsData?.dataSourceCurrentCompany?.data?.length">
      <div class="col-md-6 mb-2">
        <div class="row mb-3 mt-3">
          <div class="col-8 f-12 text-9696">
            Top Companies
          </div>
          <div class="col-4 f-12 text-9696">
            Talent Count
          </div>
        </div>
        <div class="loader text-center d-flex align-items-center justify-content-center" style="height: 80%;" *ngIf="!personInsightsData?.dataSourceCurrentCompany?.data?.length">
          <img *ngIf="!personInsightsData.dataSourceCurrentCompany" style="width: 75px;" src="../../assets/rolling-loader.gif" alt="loader" />
          </div>
        <div id="top1">
          <ng-container *ngIf="personInsightsData?.dataSourceCurrentCompany?.data?.length">
            <div class="row mb-2" *ngFor="let item of personInsightsData?.dataSourceCurrentCompany?.data | slice:0:5">
              <div class="col-8">
                <div class="d-flex p-2 w-100 align-items-center">
                  <div style="width: 50px; border-right: 1px solid #eceff4;">
                    <span class="compnaylogoplaceholder">
                      <img [src]="item.companylogo" class="img-fluid" *ngIf="item.companylogo" alt="company name">
                      <i class="fas fa-building f-12" *ngIf="!item.companylogo"></i>
                    </span>

                  </div>
                  <div class="d-grid"

                    style="margin-left: 24px;">
                    <span> {{item.label}} </span>
                    <!-- <span class="dstooltip-content">
                      <app-company-hover-modal [companyInformation]="currentCompanyInformation"></app-company-hover-modal>
                    </span> -->
                  </div>
                </div>
              </div>
              <div class="col-4 f-14 d-flex align-items-center  font-weight-600">
                <span>{{item.value | number:'1.0':'en-US'}}</span>
              </div>
            </div>
          </ng-container>
          </div>
      </div>
      <div class="col-md-6 mb-2">
        <div class="row mb-3 mt-3">
          <div class="col-8 f-12 text-9696">
            Top Industries
          </div>
          <div class="col-4 f-12 text-9696">
            Talent Count
          </div>
        </div>

        <div class="loader text-center d-flex align-items-center justify-content-center" style="height: 80%;" *ngIf="!personInsightsData?.currentIndustry?.length">
          <img *ngIf="!personInsightsData.currentIndustry" style="width: 75px;" src="../../assets/rolling-loader.gif" alt="loader" />
        </div>

        <ng-container *ngIf="personInsightsData?.currentIndustry?.length">
          <div class="row mb-2" *ngFor="let industry of personInsightsData?.currentIndustry">
            <div class="col-8">
              <div class="d-flex p-2 w-100">
                <div style="width: 50px; border-right: 1px solid #eceff4;" class="d-flex align-items-center">
                  <div class="building-icon bg-gray-new">
                    <i [class]="getIndustryIcon(industry?.key)"></i>
                  </div>
                </div>
                <div style="margin-left: 24px; height: 30px;" class="d-grid align-items-center" [matTooltip]="industry.key | titlecase"
                  [matTooltipClass]="{ 'red-tooltip text-black': true }">
                  <span class="text-truncate">{{industry.key | titlecase}}</span>
                </div>
              </div>
            </div>
            <div class="col-4 f-14 d-flex align-items-center font-weight-600">
              <span>{{industry.doc_count | number}}</span>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
  <div class="d-flex justify-content-between">
    <p class="f-16 font-weight-600 mb-3">What are related skills and titles for this talent?</p>
    <div class="text-right" class="text-right" style="width: 100px;" *ngIf="personInsightsData?.skills?.length">
      <p class="text-webbtree-green f-14 font-weight-500 pointer" (click)="startFreeTrial('Get_skills_titles_View_All_Free_Trial')">View All</p>
    </div>
  </div>
  <div class="loader text-center d-flex align-items-center justify-content-center mb-3" style="height: 100px; border: 1px solid #d5dee6;" *ngIf="!personInsightsData?.skills?.length">
    <img *ngIf="!personInsightsData.skills" style="width: 75px;" src="../../assets/rolling-loader.gif" alt="loader" />
    <span *ngIf="personInsightsData?.skills?.length == 0">No Data Available</span>
  </div>
<div class="row" *ngIf="personInsightsData?.skills?.length">
  <div class="col-md-6 mb-2">
    <div class="row mb-6">
      <div class="col-8 f-12 text-9696">
        Top Skills
      </div>
      <div class="col f-12 text-9696">
        Talent Count
      </div>
    </div>
    <div class="loader text-center d-flex align-items-center justify-content-center" style="height: 80%;" *ngIf="!personInsightsData?.skills?.length">
      <img *ngIf="!personInsightsData.skills" style="width: 75px;" src="../../assets/rolling-loader.gif" alt="loader" />
      <span *ngIf="personInsightsData?.skills?.length == 0">No Data Available</span>
    </div>
    <ng-container *ngIf="personInsightsData?.skills?.length">
      <div class="test" *ngFor="let s of personInsightsData?.skills">
        <div class="row">
          <div class="col-8 d-grid">
            <span class="text-truncate">{{s.key | titlecase}}</span>
          </div>
          <div class="col font-weight-600">
            <span>
              {{s.doc_count | number}}
            </span>
          </div>
        </div>
        <hr class="HR-seperator-in-card mb-4 mx-0">
      </div>
    </ng-container>
  </div>
  <div class="col-md-6 mb-2">
    <div class="row mb-6">
      <div class="col-8 f-12 text-9696">
        Top Titles
      </div>
      <div class="col f-12 text-9696">
        Talent Count
      </div>
    </div>
    <div class="loader text-center d-flex align-items-center justify-content-center" style="height: 80%;" *ngIf="!personInsightsData?.titles?.length">
      <img *ngIf="!personInsightsData.titles" style="width: 75px;" src="../../assets/rolling-loader.gif" alt="loader" />
      <span *ngIf="personInsightsData?.titles?.length == 0">No Data Available</span>
    </div>
    <ng-container *ngIf="personInsightsData?.titles?.length">
      <div class="test" *ngFor="let t of personInsightsData?.titles">
        <div class="row">
          <div class="col-8 d-grid">
            <span class="text-truncate">{{t.key | titlecase}}</span>
          </div>
          <div class="col font-weight-600">
            <span>
              {{t.doc_count | number}}
            </span>
          </div>
        </div>
        <hr class="HR-seperator-in-card mb-4 mx-0">
      </div>
    </ng-container>
  </div>
</div>
</div>
<div class="row">
  <div class="col pb-4">
    <div class="upgrade-feat">
      <div class="mb-1 text-center">
        <span class="text-9696 f-18"> <i class="fa-solid fa-lock-keyhole mb-1"></i></span>
        <p class="f-18 font-weight-600 mb-2">Talent Education Insights</p>
        <p class="f-14 mb-4">Upgrade your plan to access all insights.</p>
        <button data-testid="auto-app-webbtree-insights-button-2" class="btn-free-trial-primery" (click)="startFreeTrial('Get_Education_Insights_Free_Trial')"><i class="fas fa-crown"></i> Start Free Trial</button>
       </div>
    </div>
  </div>
</div>
<div class="">
  <p class="f-16 font-weight-600">How long has the talent been working?
  </p>
  <div class="row">
    <div class="col-md-6">

      <p class="f-12 font-weight-normal text-9696 "> Overall Tenure </p>
      <div class="col">
        <div class="loader h-23 center-content d-flex align-items-center justify-content-center" style="height: 100px;  border: 1px solid #d5dee6;" *ngIf="!personInsightsData?.dataSourceCurrentExperience?.data?.length">
          <img *ngIf="!personInsightsData.dataSourceCurrentExperience" style="width: 75px;" src="../../assets/rolling-loader.gif" alt="loader" />
          <span *ngIf="personInsightsData?.dataSourceCurrentExperience?.data?.length == 0">No Data Available</span>
        </div>
        <fusioncharts width="100%" height="245" type="column2d" [dataSource]="personInsightsData?.dataSourceCurrentExperience" (dataplotClick)="fusionChartsClickHandler($event, 'yearsofexperience')"
          *ngIf="personInsightsData?.dataSourceCurrentExperience && personInsightsData?.dataSourceCurrentExperience?.data?.length">
        </fusioncharts>
      </div>
    </div>

    <div class="col-md-6">
      <div class="tenure-insight">
        <img src="../../../assets/webbtree-freemium/Tenure-in-Current-Company-Insights.png" alt="">
        <div class="my-3 text-center tenure-content">
          <span class="text-9696 f-18"> <i class="fa-solid fa-lock-keyhole  mb-1"></i></span>
          <p class="f-18 font-weight-600 mb-2">Tenure in Current Company Insights </p>
          <p class="f-14 mb-4">Upgrade your plan to access all insights.</p>
          <button data-testid="auto-app-webbtree-insights-button-3" class="btn-free-trial-primery" (click)="startFreeTrial('Get_Company_Insights_Free_Trial')"><i class="fas fa-crown"></i> Start Free Trial</button>

         </div>
      </div>
    </div>
  </div>
</div>

<!-- This section hides because of complience issues -->
<!-- <div class="row">
  <div class="col-md-6">
    <div class="tenure-insight">
      <img src="../../../assets/webbtree-freemium/Talent-Nationality-Insights.png" alt="">

      <div class="my-3 text-center tenure-content">
        <span class="text-9696 f-18"> <i class="fa-solid fa-lock-keyhole mb-1"></i></span>
        <p class="f-18 font-weight-600 mb-2">Talent Nationality Insights</p>
        <p class="f-14 mb-4">Upgrade your plan to access all insights.</p>
        <button data-testid="auto-app-webbtree-insights-button-4" class="btn-free-trial-primery" (click)="startFreeTrial('Get_Nationality_Insights_Free_Trial')"><i class="fas fa-crown"></i> Start Free Trial</button>
       </div>
    </div>
  </div>
  <div class="col-md-6">
    <div class="tenure-insight">
      <img src="../../../assets/webbtree-freemium/Talent-Ethnicity-Insights.png" alt="">

      <div class="my-3 text-center tenure-content">
        <span class="text-9696 f-18"> <i class="fa-solid fa-lock-keyhole mb-1"></i></span>
        <p class="f-18 font-weight-600 mb-2">Talent Ethnicity Insights</p>
        <p class="f-14 mb-4">Upgrade your plan to access all insights.</p>
        <button data-testid="auto-app-webbtree-insights-button-5" class="btn-free-trial-primery" (click)="startFreeTrial('Get_Ethnicity_Insights_Free_Trial')"><i class="fas fa-crown"></i> Start Free Trial</button>

       </div>
    </div>
  </div>
</div> -->

<div class="row">
  <div class="col-md-6">
    <div class="tenure-insight">
      <img src="../../../assets/webbtree-freemium/Talent-Gender-Diversity-Insights.png" alt="">

      <div class="my-3 text-center tenure-content">
        <span class="text-9696 f-18"> <i class="fa-solid fa-lock-keyhole mb-1"></i></span>
        <p class="f-18 font-weight-600 mb-2">Talent Gender Diversity Insights</p>
        <p class="f-14 mb-4">Upgrade your plan to access all insights.</p>
        <button data-testid="auto-app-webbtree-insights-button-6" class="btn-free-trial-primery" (click)="startFreeTrial('Get_Gender_Insights_Free_Trial')"><i class="fas fa-crown"></i> Start Free Trial</button>

       </div>
    </div>
  </div>
  <div class="col-md-6">
    <div class="tenure-insight">
      <img src="../../../assets/webbtree-freemium/Talent-Seniority-Insights.png" alt="">

      <div class="my-3 text-center tenure-content">
        <span class="text-9696 f-18"> <i class="fa-solid fa-lock-keyhole mb-1"></i></span>
        <p class="f-18 font-weight-600 mb-2">Talent Seniorty Insights</p>
        <p class="f-14 mb-4">Upgrade your plan to access all insights.</p>
        <button data-testid="auto-app-webbtree-insights-button-7" class="btn-free-trial-primery" (click)="startFreeTrial('Get_Seniority_Insights_Free_Trial')"><i class="fas fa-crown"></i> Start Free Trial</button>

       </div>
    </div>
  </div>
</div>

